import React from "react";
import ReactApexChart from "react-apexcharts";

class ApexChart extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      series: [
        {
          name: "Female",
          data: [0, 22, 23, 28, 17]
        },
        {
          name: "Male",
          data: [19, 20, 25, 22, 15]
        }
      ],
      options: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: false,
          offsetY: 15,
          toolbar: {
            show: false 
          },
          zoom: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '50%',
            endingShape: 'rounded'
          }
        },
        colors: ["#df8f06", "#0b57cf"],
        dataLabels: {
          enabled: false
        },
        tooltip: {
          enabled: true,
          y: {
            formatter: (value) => `${value}%`
          }
        },
        xaxis: {
          tickPlacement: 'on',
          labels: {
            rotate: -90,
            rotateAlways: true,
            offsetY: 5,
          },
          categories: ["Primary", "Secondary", "(Non-Univ)", "University", "Vocational"],
          axisBorder: {
            show: true,
            color: '#000',
          },
          axisTicks: {
            show: true,
            color: '#000',
            height: 7,
          },
        },
        yaxis: {
          min: 0,
          max: 30,
          tickAmount: 6,
          axisBorder: {
            show: true,
            color: '#000',
            width: 1,
          },
          axisTicks: {
            show: true,
            color: '#000',
            width: 7,
          },
          title: {
            text: "Percentage",
            style: {
              color: '#000', 
              fontSize: '14px',
              fontWeight: 'medium',
            }
          }
        },
        grid: {
          show: true,
          strokeDashArray: 2,
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          markers: {
            show: true,
            width: 50,
            height: 50,
          },
        },
        responsive: [
          {
            breakpoint: 420,
            options: {
              chart: {
                height: "300",
              },
              plotOptions: {
                bar: {
                  columnWidth: '70%',
                }
              },
            },
          },
        ]
      },
    };
  }

  render() {
    return (
      <div>
        <div id="chart">
          <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={380} className="theme-legends" />
        </div>
      </div>
    );
  }
}

export default ApexChart;